import { render } from "./program-stats.vue?vue&type=template&id=1e6dc05d&ts=true"
import script from "./program-stats.vue?vue&type=script&lang=ts"
export * from "./program-stats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__